import React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLAttributes<HTMLDivElement>

function ListItem(props: Props) {
  const { className, children } = props

  return <li className={classNames(style.listItem, className)}>{children}</li>
}

export default ListItem
